export default __webpack_public_path__ + "static/media/Reports_Template_PAE_PSC_PSLP.7ce4dfa6.csv";